import React, { useState, useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";

import "./contact.css";

import { Notyf } from "notyf";
import "notyf/notyf.min.css"; // for React, Vue and Svelte
const notyf = new Notyf({
  duration: 1000,
  position: {
    x: "bottom",
    y: "right",
  },
});

export default function PageForm(props) {
  const form = useRef();

  const styles = {
    holder: {
      display: "block",
      maxWidth: "1368px",
      margin: "auto",
      paddingLeft: "20px",
      paddingRight: "20px",
      position: "relative",
      paddingnTop: "60px",
      paddingBottom: "60px",
      marginTop: "60px",
      marginBottom: "60px",
    },
  };
  //   GET
  const [item, setPost] = React.useState();
  //

  const [FullName, setFullName] = useState("");
  const [Company, setCompany] = useState("");
  const [Phone, setPhone] = useState("");
  const [Email, setEmail] = useState("");
  const [Message, setMessage] = useState("");
  const [Website, setWebsite] = useState("");
  const [Industry, setIndustry] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    fetch(
      `https://admin.arabian-industries.net/api/api/forms/submit/home_form?token=8c25a7a0819fe42e3a0ddb3adc68b1`,
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          form: {
            Page: item.title,
            FullName: FullName,
            Company: Company,
            Phone: Phone,
            Email: Email,
            Message: Message,
            Website: Website,
            Industry: Industry,

            SendTO: item.contact_email,
            CC: item.contact_email_cc,
          },
        }),
      }
    );
    // SEND
    emailjs
      .sendForm(
        "service_29z7q3a",
        "template_ey3c3of",
        form.current,
        "hfbnlEVS9EnR48KB3"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    //

    // Clear
    setFullName("");
    setCompany("");
    setPhone("");
    setEmail("");
    setMessage("");
    setIndustry("");
    setWebsite("");
    //
    notyf.success("Successfull.");
  };

  //
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        `https://admin.arabian-industries.net/api/api/collections/entry/` +
          `group_companies/` +
          props.propID +
          `?token=8c25a7a0819fe42e3a0ddb3adc68b1`,
        {
          method: "get",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        }
      );
      await response.json().then(function (response) {
        setPost(response);
        //console.log(response);
      });
    };
    fetchData();
  }, [props.propID]);
  //
  if (!item) return;

  return (
    <div id="LETS_TALK" style={styles.holder}>
      <div className="BGArtwork"></div>
      <div className="FormholderPage">
        <div className="FormLeft">
          {item.contact_img && item.contact_img && (
            <div
              style={{
                backgroundImage: `url(${
                  process.env.REACT_APP_IMG + item.contact_img.path
                })`,
                height: "300px",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                flexFlow: "wrap",
                borderTopLeftRadius: "40px",
                position: "relative",
                backgroundSize: "cover",
                flexDirection: "column",
                backgroundPosition: "center center",
              }}
            >
              {item.contact_title_top && (
                <div
                  style={{
                    position: "relative",
                    zIndex: "2",
                    color: "white",
                    textAlign: "right",
                    marginBottom: "30px",
                    paddingRight: "30px",
                    color: "#00E66F",
                    fontSize: "20px",
                  }}
                >
                  {item.contact_title_top_ar}
                </div>
              )}

              <h3 className="NewsTitleX arabicFont">{item.contact_title_ar}</h3>
              {/* <div className="EffTopBlur"></div>
       <div className="Blur"></div> */}
            </div>
          )}
        </div>

        <div className="FormRight">
          <div
            className="contact_content"
            dangerouslySetInnerHTML={{
              __html: item.contact_content_ar,
            }}
          />
          <form ref={form} id="Login" className="Login" onSubmit={handleSubmit}>
            {/* HIDDEN */}
            <input type="text" name="Page" defaultValue={item.title} hidden />
            {item.contact_email && (
              <input
                type="text"
                name="SendTO"
                defaultValue={item.contact_email}
                hidden
              />
            )}

            {item.contact_email_cc && (
              <input
                type="text"
                name="CC"
                defaultValue={item.contact_email_cc}
                hidden
              />
            )}
            {/*  */}
            <div className="InrDiv">
              <label htmlFor="FullName">
                شخص الاتصال*
                <input
                  type="text"
                  id="FullName"
                  name="FullName"
                  value={FullName}
                  onChange={(event) => setFullName(event.target.value)}
                  required
                  placeholder="الشخص الذي يمكن الاتصال به"
                />
              </label>
            </div>
            <div className="InrDiv">
              <label htmlFor="Company">
                الشركة *
                <input
                  type="text"
                  id="Company"
                  name="Company"
                  value={Company}
                  onChange={(event) => setCompany(event.target.value)}
                  required
                  placeholder="اسم الشركة"
                />
              </label>
            </div>
            {/* <div className="InrDiv">
              <label htmlFor="Phone">
                Phone*
                <select
                  value={Phone}
                  onChange={(event) => setPhone(event.target.value)}
                  id="Phone"
                  placeholder="Phone"
                >
                  {item.contact_Phone.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.value}
                    </option>
                  ))}
                </select>
              </label>
            </div> */}

            <div className="InrDiv">
              <label htmlFor="Email">
                البريد الالكتروني*
                <input
                  type="email"
                  id="Email"
                  name="Email"
                  value={Email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                  placeholder="البريد الالكتروني"
                />
              </label>
            </div>

            <div className="InrDiv">
              <label htmlFor="Phone">
                الهاتف *
                <input
                  type="text"
                  id="Phone"
                  name="Phone"
                  value={Phone}
                  onChange={(event) => setPhone(event.target.value)}
                  required
                  placeholder="هاتف شخص الاتصال"
                />
              </label>
            </div>

            <div className="InrDiv">
              <label htmlFor="Phone">
                الموقع الإلكتروني للشركة *
                <input
                  type="text"
                  id="Website"
                  name="Website"
                  value={Website}
                  onChange={(event) => setWebsite(event.target.value)}
                  required
                  placeholder="الموقع الإلكتروني للشركة"
                />
              </label>
            </div>

            <div className="InrDiv">
              <label htmlFor="Phone">
                الصناعة *
                <input
                  type="text"
                  id="Industry"
                  name="Industry"
                  value={Industry}
                  onChange={(event) => setIndustry(event.target.value)}
                  required
                  placeholder="وصف الخدمات/المنتجات"
                />
              </label>
            </div>

            <div
              className="InrDiv"
              style={{
                width: "100%",
              }}
            >
              <label htmlFor="Message">
                الرسالة*
                <textarea
                  id="Message"
                  value={Message}
                  onChange={(event) => setMessage(event.target.value)}
                  style={{
                    height: "200px",
                    padding: "10px",
                  }}
                  name="Message"
                  placeholder="من فضلك أخبرنا عن احتياجاتك وسنكون سعداء جدًا بإيجاد الحل الذي يناسب متطلباتك على أفضل وجه."
                />
              </label>
            </div>

            <button className="SendBtn" type="submit">
              أرسل
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
